import {httpEndpointCustom, HttpResultSimple} from "../utils/HttpUtils";


export async function invalidateInzerat(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/inzerat/${id}/invalidate`, {method: "POST"});
}

export async function validateInzerat(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/inzerat/${id}/validate`, {method: "POST"});
}